import React, { SVGProps } from 'react';

const Money: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 32 32'
        width={16}
        height={16}
        {...props}
    >
        <path
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M29 8H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1'
        />
        <path
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8m6-12 8 7m-8 9 8-7M10 8l-8 7m8 9-8-7'
        />
    </svg>
);

export default Money;
